import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useContext } from 'react'
import PropTypes from 'prop-types'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { AddMortgage } from '../../../../../constants/trackingEvents'
import { IconPlus } from '../../../../shared/Icon'
import { Button, Panel, If, Text } from '../../../..'
import { NumberedList } from '../../../../shared/List'
import Loan from './Loan'

import styles from './Loans.module.scss'

const propTypes = {
  addLoan: PropTypes.func.isRequired,
  current: PropTypes.array.isRequired,
  expired: PropTypes.array.isRequired,
  setShowPast: PropTypes.func.isRequired,
  showPast: PropTypes.bool.isRequired,
}

const Loans = ({ addLoan, current, expired, showPast, setShowPast }) => {
  const { ampli } = useContext(AmplitudeContext)
  const intl = useIntl()

  const handleAddLoan = () => {
    ampli?.clientCustomized({
      customization_type: AmplitudeEventConstants.CLIENT_ADDED_LOAN,
    })

    addLoan()
  }

  const MSG = defineMessages({
    currentLoans: {
      id: 'Mortgages.heading.currentLoans',
      defaultMessage: 'Your Current Mortgages',
    },
    currentLoan: {
      id: 'Mortgages.heading.currentLoan',
      defaultMessage: 'Your Current Mortgage',
    },
    pastLoans: {
      id: 'Mortgages.heading.expiredLoans',
      defaultMessage: 'Past Mortgages',
    },
    pastLoan: {
      id: 'Mortgages.heading.expiredLoan',
      defaultMessage: 'Past Mortgage',
    },
  })

  return (
    <div className={styles.loans}>
      <Panel.Heading className={styles.heading}>
        {current.length > 1
          ? intl.formatMessage(MSG.currentLoans)
          : intl.formatMessage(MSG.currentLoan)}
      </Panel.Heading>

      <If condition={current.length > 0}>
        <NumberedList
          className={styles.list}
          items={current}
          itemKey='id'
          render={Loan}
        />
      </If>
      <If condition={current.length === 0}>
        <Text
          className={styles.noloans}
          size='s'
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='Mortgages.noloansHTML'
            defaultMessage='We haven’t found any current loans for your home yet. {br}Add your loans to make Homebot more powerful.'
            values={{ br: <br /> }}
          />
        </Text>
      </If>

      <Button
        className={styles.addButton}
        iconStart={IconPlus}
        onClick={handleAddLoan}
        track={AddMortgage}
        data-qa='mortgage-add-loan-button'
      >
        <FormattedMessage
          id='Mortgages.loans.add'
          defaultMessage='Add a mortgage'
        />
      </Button>

      <If condition={expired.length > 0}>
        <Panel.Heading className={styles.pastMortgagesHeading}>
          {expired.length > 1
            ? intl.formatMessage(MSG.pastLoans)
            : intl.formatMessage(MSG.pastLoan)}
        </Panel.Heading>
        <If condition={!showPast}>
          <Text align='center' variant='neutralCool' variantCount='900'>
            <Button onClick={() => setShowPast(true)} minimal>
              <FormattedMessage
                id='Mortgages.pastMortgages.toggleMore'
                defaultMessage='View {quantity, number} other {quantity, plural, one {mortgage} other {mortgages}}'
                values={{ quantity: expired.length }}
              />
            </Button>
          </Text>
        </If>
        <If condition={showPast}>
          <NumberedList
            className={styles.list}
            items={expired}
            itemKey='id'
            render={Loan}
          />
        </If>
      </If>
    </div>
  )
}

Loans.propTypes = propTypes

export default Loans
